import * as React from "react";
import { ReactComponent as Loader } from "../../resources/images/Rolling.svg";
import "./style-btn-next.scss";

type Props = {
  text: string;
  styles?: React.CSSProperties;
  click?: () => void;
  showLoader?: boolean;
};

export const BtnNext: React.FC<Props> = (props) => {
  const { text, styles, click, showLoader = false } = props;

  return (
    <div
      className="btn-next-container"
      onClick={() => !showLoader && click && click()}
      style={{ ...styles}}
    >
      {showLoader ? (
        <div className="loadIcon">
          <Loader />
        </div>
      ) : (
        <label htmlFor="" className="label-text-next">
          {text}
        </label>
      )}
    </div>
  );
};
